import $ from 'jquery';
import ui from 'stores/ui';
import { PlatformSectionConfig } from 'modules/Platform/config';

const isWebview = ui.isWeiXin || ui.isQQ || ui.isWeiBo;

let openInBrowser;

function isDocHidden() {
    // @ts-ignore
    return document.visibilityState === 'hidden' || document.hidden || document.webkitHidden;
}

export function tryDownload(platform: 'ios' | 'android') {
    const appLinks = PlatformSectionConfig.header.appLink;
    // 市场唤起链接
    let dlLink = (appLinks.find(t => t.type === platform) || appLinks[0]).url;
    let openMarketTimer;
    let openBrowserTimer;

    if (!openInBrowser) {
        openInBrowser = $(
            '<div class="dlapp-open-in-browser"><p>If the download button clicks without skipping, click on the top right menu and select "Open in Browser."</p></div>'
        )
            .appendTo('body')
            .click(function() {
                openInBrowser.fadeOut();
            });
    }

    /**
     * 如果是在webview，则加个500ms定时器，用于当跳转被webview拦截后，
     * 显示使用浏览器打开的提示
     */
    if (isWebview) {
        openBrowserTimer = setTimeout(() => {
            openInBrowser.fadeIn();
        }, 500);
    }

    /**
     * 当页面触发 visibilitychange 事件时，表明唤起跳转应用市场成功
     * 那么就可以取消上面的定时器动作了
     */
    $(document).one('visibilitychange', function() {
        if (isDocHidden()) {
            clearTimeout(openMarketTimer);
            clearTimeout(openBrowserTimer);

            openInBrowser.fadeOut();
        }
    });

    window.location.replace(dlLink);
}
